var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartlist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#E7E7E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.25 18.2749C36.975 18.2749 40 21.2499 40 24.9999C40 28.6999 36.975 31.7124 33.25 31.7124C31.4375 31.7124 29.75 31.0124 28.475 29.7499L25 26.6749L21.4625 29.8124C20.25 31.0249 18.55 31.7249 16.75 31.7249C13.025 31.7249 10 28.6999 10 24.9999C10 21.2999 13.025 18.2749 16.75 18.2749C18.55 18.2749 20.25 18.9749 21.525 20.2499L25 23.3249L28.5375 20.1874C29.75 18.9749 31.45 18.2749 33.25 18.2749ZM19.75 27.9874L23.125 24.9999L19.8 22.0624C18.95 21.2124 17.8875 20.7749 16.75 20.7749C14.4125 20.7749 12.5 22.6624 12.5 24.9999C12.5 27.3374 14.4125 29.2249 16.75 29.2249C17.8875 29.2249 18.95 28.7874 19.75 27.9874ZM30.25 22.0124L26.875 24.9999L30.2 27.9374C31.05 28.7874 32.125 29.2249 33.25 29.2249C35.5875 29.2249 37.5 27.3374 37.5 24.9999C37.5 22.6624 35.5875 20.7749 33.25 20.7749C32.1125 20.7749 31.05 21.2124 30.25 22.0124Z",
    fill: "#075358"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartlist);
export default __webpack_public_path__ + "static/media/chartlist.cbb864a2cef1843aa788936837489da7.svg";
export { ForwardRef as ReactComponent };